import create from "zustand";
import { persist } from "zustand/middleware";

const authStore = create(
  persist(
    (set) => ({
      auth: null,
      moduleList: [],
      hydrated: false,
      rememberMe: false,
      secretCode: null,
      showDeleteBox: false,

      setAuthData: (data) =>
        set({
          auth: data,
        }),

      setModuleList: (data) =>
        set({
          moduleList: data,
        }),

      setRememberMe: (remember) =>
        set({
          rememberMe: remember,
        }),

      setSecretCode: (code) =>
        set({
          secretCode: code,
        }),

      clearAuthData: () =>
        set({
          auth: null,
          moduleList: [],
          secretCode: null,
        }),

      setHydrated: () =>
        set({
          hydrated: true,
        }),

      openDeleteBox: () =>
        set({
          showDeleteBox: true,
        }),

      hideDeleteBox: () =>
        set({
          showDeleteBox: false,
        }),
    }),
    {
      name: "auth-storage",
      partialize: (state) => ({
        auth: state.auth,
        moduleList: state.moduleList,
        rememberMe: state.rememberMe,
      }),
      onRehydrateStorage: () => (state) => {
        if (state) {
          state.setHydrated();
        }
      },
    }
  )
);

export const getBrandId = () => authStore.getState().auth?.brandId;

export const getAuthUser = () => authStore.getState().auth;

export const redirectToLogin = () => {
  authStore.getState().clearAuthData();
  window.location.href = "/login";
};

export default authStore;
